$(document).ready(function () {
$(document).on('click', '.option-values', function () {
  var parentLi = $(this).closest('li,.veda-collage-grid-items');
  $(this).siblings().removeClass('selected');
  $(this).addClass('selected');
  updateStockAvailability(parentLi);

  var $optionsWrapper = $(this).closest('.product-options-wrapper.desktop-only');
  var $allOptionBlocks = $optionsWrapper.find('.card-product-variant--option');
  var $currentBlock = $(this).closest('.card-product-variant--option');

  // Save reference to this swatch
  var _this = this;

  if ($currentBlock.is($allOptionBlocks.last())) {
    setTimeout(function () {
      $(_this).closest('li').find('.card-information-cart-button').trigger('click');
    }, 200);
  }
});




function updateStockAvailability(parentLi) {
    var selectedColor = parentLi.find('.variant-option--1 .option-values.selected').data('value') || null;
    var selectedSize = parentLi.find('.variant-option--2 .option-values.selected').data('value') || null;
    var selectedMaterial = parentLi.find('.variant-option--3 .option-values.selected').data('value') || null;
  console.log(selectedColor+'=='+selectedMaterial+'-'+selectedSize)
    parentLi.find('.option-values').removeClass('out-of-stock');

    var availableVariants = {};

    parentLi.find('.product-variants li').each(function () {
        var variantName = $(this).attr('data-title') || "";
        var variantQty = parseInt($(this).attr('data-quantity')) || 0;
        var variantId = $(this).attr('data-variant-id') || "";
        var variantImage = $(this).attr('data-variant-image') || "";
        var variantParts = variantName.split('-').map(part => part.trim()).filter(Boolean);
        var key = variantParts.join('-');

        availableVariants[key] = {
            inStock: variantQty > 0,
            variantId: variantId,
            variantQty: variantQty,
            variantImage: variantImage
        };
    });

    function createKey(...values) {
        return values.filter(Boolean).join('-');
    }

    var selectedVariantKey = createKey(selectedColor, selectedSize, selectedMaterial);
    var cartButton = parentLi.find('.card-information-cart-button');
    var productformId = parentLi.find('.product-buy-button input.product-variant-id');
    if (availableVariants[selectedVariantKey]) {
        var selectedVariant = availableVariants[selectedVariantKey];
      productformId.val(selectedVariant.variantId);
        cartButton
            .attr('data-var-id', selectedVariant.variantId)
            .attr('data-var-qty', selectedVariant.variantQty);

        if (selectedVariant.variantQty > 0) {
            cartButton.removeClass('out-of-stock');
        } else {
            cartButton.addClass('out-of-stock');
        }

        if (selectedVariant.variantImage) {
            parentLi.find('.card__media img.motion-reduce.main-product-img').attr('srcset', selectedVariant.variantImage);
            parentLi.find('.card__media img.motion-reduce.main-product-img').attr('src', selectedVariant.variantImage);
        }
    } else {
        cartButton.addClass('out-of-stock'); 
    }

    // **Fix out-of-stock detection**
    function checkStockAvailability(optionClass, selectedValues) {
        parentLi.find(optionClass + ' .option-values').each(function () {
            var value = $(this).data('value');
            var key = createKey(...selectedValues.map((v, i) => (i === selectedValues.indexOf(null) ? value : v)));
            if (!availableVariants[key] || availableVariants[key].variantQty <= 0) {
                $(this).addClass('out-of-stock');
            }
        });
    }

    checkStockAvailability('.variant-option--1', [null, selectedSize, selectedMaterial]);
    checkStockAvailability('.variant-option--2', [selectedColor, null, selectedMaterial]);
    checkStockAvailability('.variant-option--3', [selectedColor, selectedSize, null]);
}


setTimeout(function() {
    $('.product-options-wrapper').each(function() {
    if ($(this).find('p').length === 0) {
      $(this).hide(); 
    }
    });
}, 2000);


document.body.addEventListener('click', function(event) {
 
  if (event.target.closest('.card-information-cart-button')) {
    const button = event.target.closest('li,.veda-collage-grid-items')?.querySelector('button.product-form__submit');
    if (button) {
      button.click();
    }
      let loader = button.closest("li,.veda-collage-grid-items").querySelector("span.card-product-loader");
        if (loader) {
  loader.style.display = "inline-block"; 

  setTimeout(() => {
    loader.style.display = "none";
  }, 500);
}

  }
});
  
});


